module.exports = __webpack_public_path__ + "87d57d22108b5e9333853abc4d00fc4b.png";


//////////////////
// WEBPACK FOOTER
// ./app/components/Footer2/Testimonials/Geiger.png
// module id = 560
// module chunks = 16